import { Slot } from '@radix-ui/react-slot'
import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '@/lib/utils'

const ContainerVariants = cva(cn('mx-auto px-4'), {
  variants: {
    size: {
      default: 'max-w-[1400px] space-y-12',
      md: 'max-w-[720px] space-y-8',
      sm: 'max-w-lg space-y-8',
    },
  },
  defaultVariants: {
    size: 'default',
  },
})

interface ContainerProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof ContainerVariants> {
  asChild?: boolean
}

const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  ({ className, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : 'div'
    return (
      <Comp
        className={cn(ContainerVariants({ size, className }))}
        ref={ref}
        {...props}
      />
    )
  },
)
Container.displayName = 'Container'

export { Container, ContainerVariants }
